module.exports = __webpack_public_path__ + "img/asu-logo.2cc8dcb5.jpg";